<template>
  <div class="product-gallery product-gallery--layout--product-sidebar product__gallery" data-layout="product-sidebar">
    <div class="product-gallery__featured">
      <!-- <button type="button" class="product-gallery__zoom"  @click="zoomImage()" v-if="product.gallery.length > 0">
        <svg width="24" height="24">
          <path
            d="M15,18c-2,0-3.8-0.6-5.2-1.7c-1,1.3-2.1,2.8-3.5,4.6c-2.2,2.8-3.4,1.9-3.4,1.9s-0.6-0.3-1.1-0.7
	c-0.4-0.4-0.7-1-0.7-1s-0.9-1.2,1.9-3.3c1.8-1.4,3.3-2.5,4.6-3.5C6.6,12.8,6,11,6,9c0-5,4-9,9-9s9,4,9,9S20,18,15,18z M15,2
	c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S18.9,2,15,2z M16,13h-2v-3h-3V8h3V5h2v3h3v2h-3V13z"
          />
        </svg>
      </button> -->
      <div class="">
        
      </div>
    </div>
    <div class="product-gallery__thumbnails" id="my-gallery" v-if="galleryLoaded">

    </div>
  </div>

  <div class="product__header">
    <h1 class="product__title">
      {{(product.desc != '') ? product.desc : product.item_description}}
    </h1>
    
  </div>

  <base-image :gallery="product.gallery" :open="showImage" @close="closeImage" ></base-image>
</template>

<script>
// Import Swiper Vue.js components
// import { Swiper, SwiperSlide } from 'swiper/vue';
// import SwiperCore, { EffectFade, Autoplay, A11y, Thumbs } from 'swiper';
import BaseImage from '../../base/BaseImage.vue';

// SwiperCore.use([EffectFade, Autoplay, A11y, Thumbs ]);

export default {
  components: {
    //   Swiper,
    //   SwiperSlide,
      BaseImage
  },
  data() {
    return {
      max_stars: 5,
      data : null,
      thumbsSwiper: null,
      showImage: false,
      currentImage: null,
      galleryLoaded: false,
    };
  },
  props: {
    product: {
      type: Object,
    },
    prod_desc: {
      type: Object,
    },
    attributes: {
      type: Array
    }
  },
  computed: {
    reviewRating() {
      let rating = this.attributes.find(attribute => attribute.name === 'RATING');
      if (rating != undefined) {
        return rating.value;
      }
      return 0;
    }
  },
  methods: {
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },

    zoomImage(){
      this.showImage = true;
    },

    closeImage(){
      this.showImage = false;
    },

    cloudinaryGallery() {
        console.log(this.product.gallery);
        if(this.product.gallery.length > 0){
          const cloudName = this.$store.getters.cl_cloudname;
          const myWidget = window.cloudinary.galleryWidget({
              'cloudName': cloudName,
              "mediaAssets" : this.product.gallery,
              "thumnailProps": {
                  'width': 80,
                  'height': 80,
                  'navigationColor': '#FFF',
                  'navigationIconColor': '#000',
              },
              "videoProps": {
                  'controls': "play",
                  'autoplay': false,
                  'sound': true,
              },
              "container": '#my-gallery'
          });

          myWidget.render();
          this.galleryLoaded = true;
        }else{
          this.galleryLoaded = false;
        }
    }
  },
  created() {
  },
  beforeUpdate() {
    this.galleryLoaded = false;
    console.log('beforeUpdate');
    this.cloudinaryGallery();
  },
  updated() {
    console.log('updated');
      // console.log(this.product);
      
  }
};
</script>

<style>
    #swiperImgLg{
        min-height: 400px;
    }
    #swiperImgLg .swiper-pagination-bullets{
        display: none;
    }

    #swiperImgLg .swiper-scrollbar{
        display: none;
    }

    #swiperImgSm .swiper-pagination-bullets{
        display: none;
    }

    #swiperImgSm .swiper-scrollbar{
        display: none;
    }

    #swiperImgSm .swiper-wrapper .swiper-slide-thumb-active .image__body {
      border: 2px solid #e52727;
    }

</style>